import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function lensPath(_this__u8e3s4, path) {
  var tmp = (it) => {
    var tmp = path.p3(it);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  return _this__u8e3s4.dak(tmp, (o, it) => path.k4q(o, it));
}
function lensPath_0(_this__u8e3s4, path) {
  var tmp = (it) => {
    var tmp = path.p3(it);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  return _this__u8e3s4.dak(tmp, (o, it) => path.k4q(o, it));
}
function lensPath_1(_this__u8e3s4, path) {
  var tmp = (it) => {
    var tmp = path.p3(it);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  return _this__u8e3s4.dak(tmp, (o, it) => path.k4q(o, it));
}
function lensPath_2(_this__u8e3s4, path) {
  var tmp = (it) => {
    var tmp = path.p3(it);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  };
  return _this__u8e3s4.dak(tmp, (o, it) => path.k4q(o, it));
}
function lensPath_3(_this__u8e3s4, path) {
  return lens(_this__u8e3s4, (it) => {
    var tmp = path.p3(it);
    return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
  });
}
//region block: exports
export {
  lensPath_2 as lensPath2w8suwoygkj7s,
  lensPath_3 as lensPathswr2at65kgwf,
  lensPath_1 as lensPath2kkrykycsgvs9,
  lensPath_0 as lensPath10aseksl728gf,
  lensPath as lensPath16mstx1fbm6dz,
};
//endregion

//# sourceMappingURL=MutableReactive.lens.DataClassPath.mjs.map
